import { useStripe } from "@stripe/react-stripe-js";
import { useTranslation } from "next-i18next";
import React, { useState } from "react";

import { OutlinedButton } from "@/features/common/components/button/OutlinedButton";
import { useSubscribeWithStripe } from "@/features/subscription/hooks/useSubscribeWithStripe";

import { JoinSubscriptionConfirmPaymentButtonProps } from "../type";

export function JoinSubscriptionConfirmPaymentButton(
  props: JoinSubscriptionConfirmPaymentButtonProps,
) {
  const { subscriptionPlanId, userPaymentMethodId, onCompleted } = props;
  const { t } = useTranslation(["subscriptionPlan", "common"]);
  const stripe = useStripe();
  const [loading, setLoading] = useState(false);
  const subscribeWithStripe = useSubscribeWithStripe(subscriptionPlanId);

  /* Join button function */
  const onConfirmHandler = async () => {
    setLoading(true);
    try {
      await subscribeWithStripe({ stripe, userPaymentMethodId });
      onCompleted();
    } finally {
      setLoading(false);
    }
  };

  return (
    <OutlinedButton
      fullWidth
      buttonProps={{ disabled: loading, onClick: onConfirmHandler }}
      loading={loading}
      variant="primary"
    >
      {t("subscriptionPlan:pay")}
    </OutlinedButton>
  );
}
